<template>
  <div
    :class="[
      'py-2 px-4 flex flex-col md:flex-row justify-center items-center md:justify-between border-left border-gray-100 footer',
      { 'md:ml-[219px]': !collapsed },
      { 'md:ml-[57px]': collapsed }
    ]"
  >
    <div
      class="flex items-center gap-2 text-gray-500 text-xxs md:text-xs whitespace-nowrap"
    >
      <TimezoneClock label-class="" format="ddd, MMM Do, YYYY - h:mm A" />
      <div class="h-3 border-r border-gray-300 w-1"></div>
      <div class="flex items-center gap-1">
        {{ lastLoadLabel }}
        <RefreshIcon class="h-3" />
      </div>
    </div>
    <div class="items-center gap-2 hidden md:flex">
      <input
        v-model.number="zoomLevel"
        type="range"
        class="w-full h-1 bg-gray-200 rounded-full appearance-none cursor-pointer range-sm dark:bg-gray-700"
        min="25"
        max="100"
        step="25"
      />
      <NumberInput
        v-model="zoomLevel"
        sub-label="Zoom"
        :min="25"
        :max="100"
        :step="25"
        percent
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import moment from "moment-timezone";
import { onBeforeMount, onMounted, ref, watch } from "vue";

import NumberInput from "@/components/Seranova/NumberInput/NumberInput.vue";
import TimezoneClock from "@/components/TimezoneClock.vue";
import RefreshIcon from "@/images/refresh-ccw.svg?component";
import { useEventCalendar } from "@/SchedulerV2/useEventCalendar";

const { setCalendarZoom } = useEventCalendar();
const props = defineProps<{ collapsed?: boolean; lastLoad: Date }>();
const lastLoadInterval = ref<any>(null);
const lastLoadLabel = ref("");
const zoomLevel = ref(50);

onBeforeMount(() => {
  // Set zoom based on user preference
  const cachedZoom = localStorage.getItem("scheduler-zoom");
  if (cachedZoom) {
    zoomLevel.value = parseInt(cachedZoom, 10);
  }
});

onMounted(() => {
  startLoadTimer();
});

watch(zoomLevel, (val, oldVal) => {
  if (val !== oldVal) {
    setCalendarZoom(val);
  }
});

const startLoadTimer = () => {
  setLastLoadLabel();
  clearInterval(lastLoadInterval.value);
  lastLoadInterval.value = setInterval(setLastLoadLabel, 5000);
};

const setLastLoadLabel = () => {
  lastLoadLabel.value = `Last Updated: ${moment
    .duration(moment(props.lastLoad).diff(new Date()))
    .humanize(true)}`;
};
</script>

<style lang="scss">
.footer {
  position: relative;
  &::before {
    content: " ";
    position: absolute;
    width: 100%;
    top: -27px;
    pointer-events: none;
    left: 0px;
    height: 27px;
    opacity: 0.4;
    background: linear-gradient(
      0deg,
      rgba(148, 154, 168, 0.3) -10.34%,
      rgba(234, 238, 245, 0) 81.03%
    );
  }
}
</style>
